import { message } from 'antd';
import config from '../config/config';

message.config({
    top: 50,
    maxCount: 3
});

/**
 * @desc 封装了系统提示消息, 方便做全局配置或全局修改, 默认使用antd的message组件
 */
export default {
    error: function(msg, durationTime = config.messagerDuration, callback) {
        message.destroy();
        message.error(msg, durationTime, callback);
    },
    warn: function(msg, durationTime = config.messagerDuration, callback) {
        message.destroy();
        message.warn(msg, durationTime, callback);
    },
    info: function(msg, durationTime = config.messagerDuration, callback) {
        message.destroy();
        message.info(msg, durationTime, callback);
    },
    success: function(msg, durationTime = config.messagerDuration, callback) {
        message.destroy();
        message.success(msg, durationTime, callback);
    }
};



// WEBPACK FOOTER //
// ./src/utils/messager.js